import React from 'react'
import PropTypes from 'prop-types'

export const StatusMarker = ({ iconType }) => (
  <div className="status-marker">
    <div className={`${iconType}`} />
  </div>
)
StatusMarker.propTypes = {
  iconType: PropTypes.string,
}
